// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maintenance-window-width[data-v-3c02f17e] {\n  width: 320px;\n  max-width: 320px;\n}", ""]);
// Exports
module.exports = exports;
